import { render, staticRenderFns } from "./FormTaxRateLocale.vue?vue&type=template&id=3ae46dc2&scoped=true&"
import script from "./FormTaxRateLocale.vue?vue&type=script&lang=js&"
export * from "./FormTaxRateLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae46dc2",
  null
  
)

export default component.exports